import { Divider, Paper } from "@mui/material";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import InterfaceHead from "./InterfaceHead";
import CreateNewFamily from "./CreateNewFamily/CreateNewFamily";
import InterfaceDetailSkeleton from "./InterfaceDetailSkeleton";
import { selectUserToken } from "../../../../../features/userSlice";
import { familiesEndPointLogic } from "../../../../../logic/DataCollection/Families/FamiliesEndPointLogic";
import { useWebsiteSharedUid } from "../../../../../customHooks/useWebsiteSharedUid";

const Interface = () => {
  const [searchParams] = useSearchParams();
  const interfaceId = searchParams.get("interfaceId");
  const dispatch = useDispatch();
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  // Families data spans all interfaces/brands, not scoped to one website —
  // the EP treats website_shared_uid as a required dummy input here, so we
  // pass the first website_shared_uid the user can access from /me.
  const website_shared_uid = useWebsiteSharedUid();
  const {
    interfaceCoverage,
    familiesOverviewByInterface,
    isFamiliesOverviewLoading,
    brandStepCoverage,
  } = useSelector((state: any) => state.families);

  useEffect(() => {
    if (!interfaceCoverage.length) {
      familiesEndPointLogic.getInterfaceCoverage(
        oauthTokenHeader,
        website_shared_uid,
        dispatch,
      );
    }
    familiesEndPointLogic.getFamiliesOverview(
      oauthTokenHeader,
      website_shared_uid,
      interfaceId,
      dispatch,
    );
    familiesEndPointLogic.getBrandStepCoverage(
      oauthTokenHeader,
      website_shared_uid,
      dispatch,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interfaceId]);

  const interfaceRow = interfaceCoverage.find(
    (row: any) => String(row.backend_interface_id) === String(interfaceId),
  );
  const interfaceDetail = familiesOverviewByInterface;

  return (
    <>
      <Paper>
        <InterfaceHead interfaceRow={interfaceRow} />
        <Divider />
        {isFamiliesOverviewLoading ? (
          <InterfaceDetailSkeleton />
        ) : (
          <CreateNewFamily
            interfaceDetail={interfaceDetail}
            interfaceName={interfaceRow?.interface_name}
            brandStepCoverage={brandStepCoverage}
            interfaceId={interfaceId}
            coverageRow={interfaceRow}
          />
        )}
      </Paper>
    </>
  );
};

export default Interface;
